export default __webpack_public_path__ + "images/main-loader.gif";